<template>
  <VAppLayout>
    <VContainer>
      <div class="tips-container">
        <div class="tips-header">
          <h1>{{ $t('pages.tip.title') }}</h1>
          <div class="tips-subtitle" v-html="$t('pages.tip.subtitle')"></div>
        </div>
        <div class="waiters-wrapper">
            <div v-for="waiter in waitersList" :key="waiter.id" class="waiter-item" @click="openWaiterPage(waiter.code)">
              <div class="waiter-avatar">
                <img
                    v-if="waiter.imagePath.length > 5"
                    :src="waiter.imagePath"
                    :alt="waiter.name"
                    @error="handleImageError"
                    :class="{ 'image-error': imageLoadError }"
                />
                <img
                    v-else
                    src="@/assets/img/tiptip/userPlaceholder.png"
                    :alt="waiter.name"
                />
              </div>
              <h2>{{ waiter.name }}</h2>
            </div>
        </div>
        <div class="waiters-footer">
          <div >
            <img src="@/assets/img/tiptip/tiptiplogo.png" alt="TipTip Logo" />
            <span>{{ $t('pages.tip.footer') }}</span>
          </div>
        </div>
      </div>
    </VContainer>
  </VAppLayout>
</template>

<script>

import VAppLayout from "@/layouts/VAppLayout.vue";
import VContainer from "@/components/ui/VContainer.vue";

export default {
  name: "TipsTab",
  components: {
    VContainer,
    VAppLayout
  },
  data() {
    return {
    };
  },
  mounted() {

  },
  computed: {
    waitersList() {
      let list = this.$store.getters['getWaitersList'];
      list = list.filter(waiter => waiter.is_active === 1);
      return list;
    }
  },
  methods: {
    openWaiterPage(code) {
      //open new tab
      const url = `https://daj.tiptip.com.pl/${code}`;
      window.open(url, '_blank');
    },
    handleImageError() {
      this.imageLoadError = true;
      // Можна замінити src на placeholder
      event.target.src = require('@/assets/img/tiptip/userPlaceholder.png');
    }
  }
}
</script>

<style scoped>
.tips-container {
  padding: 24px 0;
  max-width: 700px;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  margin: auto;
}

.tips-container .tips-header {
  margin-bottom: 24px;
  padding: 10px;
}

.tips-container .tips-header h1 {
  font-size: 32px;
  margin: 0 0 8px 0;
  font-weight: bold;
}

.tips-container .tips-header .tips-subtitle {
  font-size: 16px;
  color: black;
  font-weight: normal;
}

.tips-container .waiters-wrapper {
  gap: 10px;
  flex-flow: column;
  display: flex;
}

.tips-container .waiters-wrapper .waiter-item {
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: #F5F5F5;
  border-radius: 20px;
  border: 1px solid #E6E6E6;
  padding: 5px;
}

.tips-container .waiters-wrapper .waiter-item .waiter-avatar {
  margin-right: 15px;
}

.tips-container .waiters-wrapper .waiter-item .waiter-avatar img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 50px;
}

.tips-container .waiters-wrapper .waiter-item h2 {
  font-size: 20px;
  margin: 0;
  font-weight: bold;
}

.tips-container .waiters-footer {
  margin-top: auto;
  padding: 20px 0 0 0;
  text-align: center;
  color: #929292;
  font-size: 12px;
}

.tips-container .waiters-footer div {
  display: flex;
  flex-flow: column;
  align-items: center;
}

.tips-container .waiters-footer div span {
  margin: 0;
}


</style>
